import Typography from '@mui/joy/Typography'
import { Link } from 'react-router-dom'

export const CampaignCompleted = ({ id }) => {
    return (
        <>
            <Link to={`/merchant/view_campaign_v2/${id}`}>
                <Typography color="neutral" level="h3">
                    Campaign {id} Created!
                </Typography>
            </Link>
        </>
    )
}
